import { Component, ElementRef, Input, Optional, Self, ViewChild } from '@angular/core';
import { NgControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NgxCurrencyConfig, NgxCurrencyInputMode } from 'ngx-currency';
import { StorageService } from '@core/services/storage.service';
import { InputV2Component } from '../input-v2/input-v2.component';

@Component({
  selector: 'currency-input',
  templateUrl: './currency-input.component.html',
  styleUrls: ['../input-v2/input-v2.component.scss']
})
export class CurrencyInputComponent extends InputV2Component {
  @Input() currencyMaskOptions: Partial<NgxCurrencyConfig> | null = null;
  @Input() displayPrefix: string = '';
  @ViewChild('inputv2') inputv2: ElementRef<HTMLInputElement>;

  constructor(
    @Optional()
    @Self()
    ngControl: NgControl,
    t: TranslateService,
    public storage: StorageService
  ) {
    super(ngControl, t);
  }

  get inputClassName(): { [key: string]: boolean } {
    return { 'error-border': this.isInvalid && this.isTouched && !!this.errorMessage };
  }

  get inputStyle(): { [key: string]: string } {
    return this.prependSrc
      ? {
          background: `url(${this.prependSrc}) no-repeat scroll 16px 11px`,
          paddingLeft: '42px'
        }
      : {};
  }

  get currencyMaskConfig(): Partial<NgxCurrencyConfig> {
    return (
      this.currencyMaskOptions || {
        align: 'left',
        allowNegative: false,
        allowZero: true,
        decimal: this.storage?.decimalSymbol || ',',
        precision: 2,
        prefix: this.displayPrefix,
        suffix: '',
        thousands: ' ',
        nullable: true,
        min: null,
        max: null,
        inputMode: NgxCurrencyInputMode.Natural
      }
    );
  }

  get inputMode(): string {
    return 'decimal';
  }

  override onWheel(event: WheelEvent): void {
    event.preventDefault();
  }
}
